"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _clsx = _interopRequireDefault(require("clsx"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.css"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero3 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var PFAHeroTextBlock = function PFAHeroTextBlock(_ref) {
  var data = _ref.data,
    isCarousel = _ref.isCarousel;
  var _ref2 = data || {},
    iconImage = _ref2.logoURL,
    subtitle = _ref2.headingSmall,
    title = _ref2.headingLarge,
    description = _ref2.description,
    disclaimerData = _ref2.disclaimerData,
    ctaLinks = _ref2.ctas,
    mksTagId = _ref2.mksTagId;
  var renderCtas = function renderCtas(mksTagId) {
    var handleClick = function handleClick(_ref3) {
      var label = _ref3.label,
        mksTagId = _ref3.mksTagId;
      var modelName = '';
      if (window.location && window.location.pathname) {
        var pathnames = window.location.pathname.split('/');
        var pathnamePosition = pathnames.length >= 3 ? 2 : 1;
        // eslint-disable-next-line prefer-destructuring
        modelName = pathnames[pathnamePosition];
      }
      window.dataLayer.push(_objectSpread(_objectSpread({
        event: 'linkclickevent',
        section_name: mksTagId,
        component: !isCarousel ? 'PFA' : 'Carousel PFA',
        action: 'CTA click',
        click_text: label
      }, isCarousel && {
        component_heading: title
      }), {}, {
        nameplate: isCarousel ? '' : modelName
      }));
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (ctaLinks == null ? void 0 : ctaLinks.length) > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _pfaHero["default"]['ctas-container']
    }, ctaLinks.map(function (_ref4) {
      var label = _ref4.label,
        link = _ref4.link,
        backgroundCTA = _ref4.backgroundCTA,
        openNewTab = _ref4.openNewTab;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _pfaHero["default"]['cta-container']
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: link,
        onClick: function onClick() {
          return handleClick({
            label: label,
            mksTagId: mksTagId
          });
        },
        className: (0, _clsx["default"])(_pfaHero["default"].cta, _pfaHero["default"][backgroundCTA]),
        target: openNewTab ? '_blank' : ''
      }, label));
    })));
  };
  var renderTextBlock = function renderTextBlock(description) {
    var convertDescription = description !== "" ? description.split('<br>') : description;
    var windowSize = window.innerWidth;
    if (windowSize < 950) {
      var descriptionText = description.replace(/<br\s*\/?>/gi, '');
      return /*#__PURE__*/_react["default"].createElement(_text.Text, {
        className: (0, _clsx["default"])(_pfaHero["default"]['pfa-hero-description']),
        text: descriptionText,
        tag: "p",
        disclaimerData: disclaimerData
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, convertDescription && convertDescription.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, convertDescription.map(function (desc, index) {
      return /*#__PURE__*/_react["default"].createElement(_text.Text, {
        key: index,
        className: (0, _clsx["default"])(_pfaHero["default"]['pfa-hero-description'], convertDescription.length - 1 === index && _pfaHero["default"]['pfa-hero-description-last']),
        text: desc,
        tag: "p",
        disclaimerData: disclaimerData
      });
    })));
  };
  var renderHeroContent = function renderHeroContent() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, iconImage && /*#__PURE__*/_react["default"].createElement("figure", {
      className: _pfaHero["default"]['top-safety-image']
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: iconImage || '/awards.svg'
    })), subtitle && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _pfaHero["default"].subtitle,
      text: subtitle,
      tag: "p",
      disclaimerData: disclaimerData
    }), title && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _pfaHero["default"].title,
      text: title,
      tag: "h1",
      disclaimerData: disclaimerData
    })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderTextBlock(description), renderCtas(mksTagId)));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: _pfaHero["default"]['hero-content']
  }, renderHeroContent()));
};
PFAHeroTextBlock.displayName = 'PFAHeroTextBlock';
PFAHeroTextBlock.defaultProps = {
  data: _pfaHero2["default"]
};
var _default = exports["default"] = PFAHeroTextBlock;